module.exports = __webpack_public_path__ + "img/医疗装备行业结构示意图.b49f36c7.jpg";